// extracted by mini-css-extract-plugin
export default {"viewContainer":"styles-module__viewContainer__src-labstep-web-components-Comment-SideMenu-_m_HLM"};